<template>
  <div>

    <label :for="($attrs?.id as string) ?? id" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-right">{{
      label }}</label>

    <input ref="input" v-model="model" type="text" :id="($attrs?.id as string) ?? id"
      class="bg-gray-50 border border-gray-300 read-only:bg-white read-only:cursor-default  text-gray-900 focus:outline-none text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary focus:shadow-xl transition-shadow duration-300"
      v-bind="$attrs" />

      <div class="text-red-500 text-xs text-right mt-2" v-if="error">
        {{ error }}
      </div>
  </div>
</template>

<script setup lang="ts">

import { useVModel } from '@vueuse/core'
import { uniqueId } from 'lodash';
import { ref } from 'vue';
const props = defineProps<{
  modelValue?: any,
  label?: string,
  error?: string,
}>()

const id = uniqueId()

const input = ref<HTMLInputElement | null>(null)

const emit = defineEmits(['update:modelValue'])

const model = useVModel(props, 'modelValue', emit)

function getInputElement() {
  return input.value
}

defineExpose({
  getInputElement,
})

</script>

<style scoped></style>